export default __webpack_public_path__ + "static/media/newfog6.7452bbec.png";